import { Settings } from 'lucide-react';
import { useNavigate } from '@tanstack/react-router';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

export function SettingsButton() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate({ to: '/settings' });
  };

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          onClick={handleClick}
          className={cn(
            'flex h-9 w-9 items-center justify-center',
            'rounded-full bg-hygge/10',
            'transition-colors',
            'hover:bg-hygge/20',
            'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
            'cursor-pointer'
          )}
          aria-label="Open settings"
        >
          <Settings className="h-4 w-4 text-hygge" />
        </button>
      </TooltipTrigger>
      <TooltipContent side="bottom">
        <p>Settings</p>
      </TooltipContent>
    </Tooltip>
  );
}
